<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('table_placeholder_search') || '客户名称/方案名称 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditPage', { pageType: 'add' })"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="175px" size="small">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_search_evgPackingSchemeStatus') || '状态'"
            >
              <el-checkbox-group v-model="form.listEvgPackingSchemeStatus">
                <el-checkbox label="N">
                  {{ $l('form_label_evgPackingSchemeStatus_N') || '草稿' }}
                </el-checkbox>
                <el-checkbox label="S">
                  {{ $l('form_label_evgPackingSchemeStatus_S') || '已停用' }}
                </el-checkbox>
                <el-checkbox label="Y">
                  {{ $l('form_label_evgPackingSchemeStatus_Y') || '已启用' }}
                </el-checkbox>
                <el-checkbox label="D">
                  {{ $l('form_label_evgPackingSchemeStatus_D') || '已删除' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_evgPackingSchemeNo') || '方案编号'"
            >
              <el-input
                v-model.trim="form.evgPackingSchemeNo"
                :placeholder="
                  $l('form_placeholder_evgPackingSchemeNo') ||
                    '请输入大货包装方案编号'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_evgPackingSchemeName') || '方案名称'"
            >
              <el-input
                v-model.trim="form.evgPackingSchemeName"
                :placeholder="
                  $l('form_placeholder_evgPackingSchemeName') ||
                    '请输入包装方案名称'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_salesPersonCode') || '业务人员'"
            >
              <dict-select
                v-model="form.listSalesPersonCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('form_placeholder_salesPersonCode') || '请选择业务人员'
                "
                clearable
                filterable
                multiple
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_merchandiserCode') || '跟单人员'"
            >
              <dict-select
                v-model="form.listMerchandiserCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('form_placeholder_merchandiserCode') || '请选择跟单人员'
                "
                clearable
                filterable
                multiple
                style="width:100%"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_ftyPersonCode') || '工厂跟单人员'"
            >
              <dict-select
                v-model="form.listFtyPersonCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('form_placeholder_ftyPersonCode') || '请选择工厂跟单人员'
                "
                clearable
                filterable
                multiple
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_custCode') || '客户'">
              <dict-select
                v-model="form.custCode"
                url="/master/common/dict/customerSelect"
                :placeholder="$l('form_placeholder_custCode') || '请选择客户'"
                clearable
                filterable
                style="width:100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_platformCode') || '渠道'"
              prop="platformCode"
            >
              <dict-select
                v-model="form.platformCode"
                url="/ecom/evg/platform/select"
                :placeholder="
                  $l('form_placeholder_platformCode') || '请选择渠道'
                "
                filterable
                clearable
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_regionCode') || '运抵国'"
              prop="regionCode"
            >
              <dict-select
                v-model="form.regionCode"
                url="/master/common/dict/biz"
                :body="{ dictType: 'region' }"
                :placeholder="
                  $l('form_placeholder_regionCode') || '请选择运抵国'
                "
                filterable
                clearable
                style="width:100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_bookingType') || '订舱类型'"
              prop="bookingType"
            >
              <dict-select
                v-model="form.bookingType"
                :placeholder="
                  $l('form_placeholder_bookingType') || '请选择出运箱型'
                "
                :body="{ dictType: 'bookingType' }"
                url="/sys/common/dict/system"
                clearable
                filterable
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_containerName') || '出运箱型'"
              prop="containerName"
            >
              <dict-select
                v-model="form.containerName"
                url="/ecom/master/container/select"
                :placeholder="
                  $l('form_placeholder_containerName') || '请选择出运箱型'
                "
                clearable
                filterable
                style="width:100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_dispatchPort') || '出运港口'"
              prop="dispatchPort"
            >
              <dict-select
                v-model="form.dispatchPort"
                url="/master/port/select"
                :placeholder="
                  $l('form_placeholder_dispatchPort') || '请选择出运港口'
                "
                clearable
                filterable
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('form_label_createDate') || '创建时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginCreateDate"
                    :placeholder="
                      $l('form_placeholder_beginCreateDate') || '请选择创建时间'
                    "
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="beginCreateDatePicker"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endCreateDate"
                    :placeholder="
                      $l('form_placeholder_endCreateDate') || '请选择创建时间'
                    "
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="endCreateDatePicker"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('form_label_modifyDate') || '修改时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginModifyDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="beginModifyDatePicker"
                    :placeholder="
                      $l('form_placeholder_beginModifyDate') || '请选择修改时间'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endModifyDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="endModifyDatePicker"
                    :placeholder="
                      $l('form_placeholder_endModifyDate') || '请选择修改时间'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  listEvgPackingSchemeStatus: ['N', 'S', 'Y'],
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      //创建日期限制
      beginCreateDatePicker: this.endCreateDate(),
      endCreateDatePicker: this.beginCreateDate(),
      //修改日期限制
      beginModifyDatePicker: this.endModifyDate(),
      endModifyDatePicker: this.beginModifyDate(),
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    // 创建日期限制
    endCreateDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endCreateDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endCreateDate).getTime() < time.getTime()
          }
        },
      }
    },
    beginCreateDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginCreateDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginCreateDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 修改时间限制
    endModifyDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endModifyDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endModifyDate).getTime() < time.getTime()
          }
        },
      }
    },
    beginModifyDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginModifyDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginModifyDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
